module.exports = __webpack_public_path__ + "static/media/model-navara-d40.826fc352.jpg";